import {http} from '../utils'

// 营销短信模板 start
// 查询
const searchAction = (params) => {
  const url = `/market/management/template/page`
  return http.post(url, params)
}
// 获取sign列表
const getSign= (params) => {
  const url = `/market/management/sign/all`
  return http.post(url, params)
}
// 获取status列表
const getStatus = (type) => {
  const url = `/market/common/codeList/${type}`
  return http.post(url)
}
// 获取group列表
const getGroup = (params) => {
  const url = '/market/management/group/all'
  return http.post(url, params)
}
// 获取 详情
const getAction = (id) => {
  const url = `/market/management/template/detail/${id}`
  return http.post(url)
}
// 新建
const addAction = (params) => {
  const url = `/market/management/template/save`
  return http.post(url, params)
}
// 删除
const deleteAction = (id) => {
  const url = `/market/management/template/delete/${id}`
  return http.post(url)
}
// 获取group列表
const syncAction = () => {
  const url = '/market/management/template/sync'
  return http.post(url)
}

export default {
  searchAction,
  getSign,
  getStatus,
  getGroup,
  getAction,
  addAction,
  deleteAction,
  syncAction
}
